import {isoLocales} from "../components/lib/payments/PaymentController";
import {getShopId} from "../components/lib/getShopId";
import {CurrencyCode} from "@connox/typescript-library/types/cart/CurrencyCode";

const formatCurrency = (value: number, currencyCode: CurrencyCode): string => {
  // Intl is very similar with library which used by ecs-api, for more infos check FormatterService.php line 69 method name: formatMoney
  // for more infos go to https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
  const formatter = new Intl.NumberFormat(isoLocales[getShopId()].replace("_", "-"), {
    style: "currency",
    currency: currencyCode,
  });

  if (currencyCode === "DKK") {
    return formatter.format(value).replace("kr.", "DKK");
  }

  return formatter.format(value);
};

export default formatCurrency;
